
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.3 10c-.358 0-.663-.122-.918-.367A1.182 1.182 0 010 8.75v-7.5C0 .906.127.612.382.367.637.123.942 0 1.3 0h3.9l1.3 1.25h5.2c.357 0 .664.123.918.367.255.245.382.54.382.883v6.25c0 .344-.127.638-.382.883A1.28 1.28 0 0111.7 10H1.3z"}})])
          )
        }
      }
    